import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericContentPageComponent } from './generic-content-page.component';


@NgModule({
  declarations: [
    GenericContentPageComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class GenericContentPageModule { }